<script setup lang="ts">
const { idledFor } = useInactivityMonitor()

const userStore = useUserStore()

const showInactivityDialog = ref(false)

const handleClosed = () => {
  showInactivityDialog.value = false
}

watch(idledFor, async (idledFor) => {
  if (!(idledFor >= 60 * 30)) return // 30 minutes

  await userStore.logoutUser({ redirectQuery: true })

  showInactivityDialog.value = true
})
</script>

<template>
  <LazyDialog
    v-model="showInactivityDialog"
    @closed="handleClosed"
  >
    <template #header>
      <h2 class="font-bold font-nunito text-xl self-stretch leading-[26px]">Your session has timed out</h2>
    </template>
    <template #body>
      <p class="font-nunito text-[16px] text-center self-stretch">
        You have been logged out due to inactivity. Please log in again.
      </p>
    </template>
    <template #actions>
      <UIButton
        class="w-[180px] font-nunito font-bold text-[16px]"
        color="primary"
        rounded="full"
        @click="handleClosed"
      >
        Done
      </UIButton>
    </template>
  </LazyDialog>
</template>
